export default "__VITE_ASSET__BoZuxuvL__"